module.exports = {
  imageMaxWidth: 700,
  imageMaxWidthHero: 850,

  // Changing this has a negative SEO impact
  postsPerPage: 9,
  // This is so that we know how many posts to remove from a feed page with a hero item on top to make up for its height. MUST be smaller than postsPerPage.
  postsPerRow: 3
};
